import * as axios from 'axios';
import { getAuthHeader } from '../utils';

export const recentJobPost = () => {
    const url = `${process.env.REACT_APP_BASE_URL}/ejsh-recent-job-post`;
    return axios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}
export const isKYCVerified = () => {
    const url = `${process.env.REACT_APP_BASE_URL}/ejsh-is-kyc-verified`;
    return axios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}


export const recentCampusJobPost = () => {
    const url = `${process.env.REACT_APP_BASE_URL}/ejsh-recent-campus-job-post`;
    return axios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const recentCampusInternshipPost = () => {
    const url = `${process.env.REACT_APP_BASE_URL}/ejsh-recent-campus-internship-post`;
    return axios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}




export const getRewardsList = (page) => {
    const url = `${process.env.REACT_APP_BASE_URL}/emp-rewards-list?page=${page}&limit=${20}`;
    return axios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}
export const getGlobalSetting = () => {
    const url = `${process.env.REACT_APP_BASE_URL}/global-settings-details`;
    return axios.get(url).then((res) => {
        return res.data;
    })
};


